<div *ngIf="data" class="charts-container">
<!--  <app-help-icon-button *ngIf="country" [code]="this.countryCategory === 'putonmarket' ? 'kfcharts.Country.PutOnMarket.CountryVsWeeeForum' : 'kfcharts.Country.Collected.CountryVsWeeeForum'" align="end" style="display: block"></app-help-icon-button>-->
<!--  <app-help-icon-button *ngIf="!country" [code]="this.countryCategory === 'putonmarket' ? 'kfcharts.WeeeSystem.PutOnMarket.CountryVsWeeeForum' : 'kfcharts.WeeeSystem.Collected.CountryVsWeeeForum'" align="end" style="display: block"></app-help-icon-button>-->
  <div [chart]="chart"></div>
  <p>Last modified date: {{data[0]?.lastModifiedDate | date: 'dd/MM/yyyy, h:mm a'}}</p>
  <div style="display: flex">
    <p>{{textBelow}}</p>
    <mat-icon *ngIf="isAdmin" matTooltip="Edit help text" color="primary" class="pointer" (click)="editTextBelow()" style="margin-left: 4px">edit</mat-icon>
  </div>
</div>
